import TaskType from './TaskType';

enum TaskCategory {
  INTERNAL_DIALOG = 'internal_dialog',
  CLIENT_DIALOG = 'client_dialog',
  DIAGNOSE_READY = 'diagnose_ready',
}

export default TaskCategory;

export const TASK_TYPES_BY_CATEGORY = {
  [TaskCategory.INTERNAL_DIALOG]: [
    TaskType.OBSERVATION,
    TaskType.DOSSIER,
    TaskType.CHECKLIST,
    TaskType.REPAIR_ORDER,
    TaskType.GENERAL_DOSSIER,
    TaskType.INTERNAL_DIALOG,
    TaskType.CAR_IS_CLEANED,
  ],
  [TaskCategory.CLIENT_DIALOG]: [
    TaskType.DIALOG,
    TaskType.CHAT,
    TaskType.BOOKING,
    TaskType.QUOTE,
    TaskType.NEGATIVE_CUSTOMER_REVIEW,
    TaskType.KEY_DROP_DOSSIER,
    TaskType.KEY_DROP_CLIENT,
  ],
  [TaskCategory.DIAGNOSE_READY]: [
    TaskType.FRONT_OFFICE_ALERT,
  ],
};
